import {createSelector} from 'reselect';
import {getBrand} from "./createAppointmentRequest";

const getRoot = state => state;
const getState = createSelector(getRoot, state => state.dealers);
const getDealers = createSelector(getState, ({dealers}) => dealers);
export const getDealersIdsAndName = createSelector(getState, ({dealers}) => Object.values(dealers).map(({id, dealerName}) => ({id, dealerName})));
export const getDealersByBrands = createSelector(getDealers, getBrand, (dealers, brand) =>
  brand ? Object.values(dealers).filter(dealer => (dealer.supportedBrands.includes(brand))) : dealers
);
export const isLoadingDealers = createSelector(getState, ({loading}) => loading);



// WEBPACK FOOTER //
// ./src/selectors/dealers.js